export default __webpack_public_path__ + "static/media/USAnewImmigrant.9ad88f4e.jpg";